<template>
  <div class="BoxAnotacoes">
    <div class="BoxAnotacoes_header w-100 d-inline-flex align-items-center justify-content-between p-2"
         :class="`BoxAnotacoes_header_${propRegistro.status}`">
      <div class="d-inline-flex align-items-center">
        <IconSvg v-if="propRegistro.status != 'CUMPRIDA' & propRegistro.status != 'CUMPRIDA_MANUAL'"
                 :icon="statusIcon[propRegistro.status]"
                 class="icon--sm m-0 p-0 mx-2 icons--white" />
        <div class="ml-2">
          {{ getNome() }}
          <br>
          <small>Registro a ser anotado: </small> {{ propRegistro.registroAnterior.matricula_anterior | maskMatricula }}
        </div>
      </div>
      <button v-if="propRegistro.status != 'CUMPRIDA' && propRegistro.status != 'CUMPRIDA_MANUAL'"
              class="btn btn-outline-light"
              @click="showPendencias(`BoxPendencia${propIndex}`)">
        Pendências {{ propRegistro.errors ? `(${getQtdErrors(propRegistro.errors.length)})` : '' }}
      </button>
      <div v-if="propRegistro.status === 'CUMPRIDA_MANUAL'"
           class="mr-3">
        <b class="mr-2"> Envio Manual</b>
        <IconSvg icon="touch"
                 class="icon--sm icon-cumprida-manual" />
      </div>
    </div>
    <div class="BoxAnotacoes_body col-12 d-inline-flex justify-content-between p-2 m-0">
      <div>
        <p class="m-0 p-0 BoxAnotacoes_body_title">
          Serviço
        </p>
        <p class="m-0 p-0">
          Anotação
        </p>
        <div class="BoxAnotacoes_body_second-line">
          <p class="m-0 p-0 BoxAnotacoes_body_title">
            Matrícula
          </p>
          <p class="m-0 p-0 BoxAnotacoes_body_text">
            {{ propRegistro.registro.matricula | maskMatricula }}
          </p>
        </div>
      </div>
      <div>
        <p class="m-0 p-0 BoxAnotacoes_body_title">
          Data
        </p>
        <p class="m-0 p-0 BoxAnotacoes_body_text">
          {{ propRegistro.data_inclusao | date }}
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxAnotacoes_body_title">
          Data máxima para cumprir
        </p>
        <p class="m-0 p-0 BoxAnotacoes_body_text">
          {{ propRegistro.data_max_cumprimento | date }}
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxAnotacoes_body_title">
          Data de cumprimento
        </p>
        <p v-if="propRegistro.data_cumprimento"
           class="m-0 p-0 BoxAnotacoes_body_text">
          {{ propRegistro.data_cumprimento | date }}
        </p>
        <p v-else
           class="m-0 p-0 BoxAnotacoes_body_text">
          Não cumprida
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxAnotacoes_body_title">
          Data Registro
        </p>
        <p class="m-0 p-0 BoxAnotacoes_body_text">
          {{ propRegistro.registro.data_registro | date }}
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxAnotacoes_body_title">
          Tipo de registro
        </p>
        <p class="m-0 p-0 text-capitalize BoxAnotacoes_body_text">
          {{ tipos[propRegistro.registro.tipo_registro] }}
        </p>
      </div>
      <div class="BoxAnotacoes_body_tipo">
        <p class="m-0 p-0 BoxAnotacoes_body_title">
          Tipo de Anotação
        </p>
        <p class="m-0 p-0 BoxAnotacoes_body_text">
          {{ getTipoComunicacao() }}
        </p>
      </div>
      <div v-if="false">
        <p class="m-0 p-0 BoxAnotacoes_body_title">
          OS
        </p>
        <p class="m-0 p-0 BoxAnotacoes_body_text">
          {{ propRegistro.registro.ordemServico.map(os => os.ordem_servico_id).join(", ") || "Sem OS" }}
        </p>
      </div>
    </div>
    <div>
      <BoxPendencias :ref="`BoxPendencia${propIndex}`"
                     :prop-errors="propRegistro.errors"
                     :prop-tarefa-id="propRegistro.tarefa_id"
                     :prop-tarefa="propRegistro"
                     @reload="reload()"
                     @averbar="averbar()" />
    </div>
    <b-modal v-if="showModal"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             :hide-header="true"
             :hide-footer="true">
      <AverbacaoSV :registro-id="registro_id"
                   :prop-show-text="false"
                   :prop-tarefa-id="propRegistro.tarefa_id"
                   prop-show-text-anotacao
                   prop-imprimir
                   @reload="reload()"
                   @hideModal="showModal = false" />
    </b-modal>
  </div>
</template>
<script>
  // components
  import BoxPendencias from '@/components/SofiaRei/Gerenciador/BoxPendencias.vue'
  import AverbacaoSV from '@/components/SofiaRei/Nascimento/SegundaVia/AverbacaoSV'
  import { mapGetters } from "vuex"

  // services
  import BuscaService from '@/services/BuscaService'

  export default {
    name: 'BoxAnotacoes',
    components: {
      BoxPendencias,
      AverbacaoSV
    },
    props: {
      propRegistro: {type: Object, default: () => ({})},
      propSelected: {type: Boolean, default: false},
      propIndex: {type: Number, default: null}
    },
    data () {
      return {
        tipos: {
          "O": "óbito",
          "N": "nascimento",
          "C": "casamento",
          "CR": "casamento religioso",
        },
        statusIcon: {
          "A_VENCER": "calendarAlert",
          "VENCIDA": "alert",
        },
        localData: {
          tarefa_id: null
        },
        showModal: false,
        registro_id: null
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: "auth/getCartorioId"
      })
    },
    watch: {
      propSelected () {
        if (this.propSelected) this.localData.tarefa_id = this.propRegistro.tarefa_id
        else this.localData.tarefa_id = null
      }
    },
    methods: {
      changeSelected () {
        setTimeout (() => {
          if (this.localData.tarefa_id) {
            this.$emit('addSelected', this.localData.tarefa_id)
          } else {
            this.$emit('removeSelected', this.propRegistro.tarefa_id)
          }
        }, 100)
      },
      getNome () {
        if (this.propRegistro.registro.pessoas.length === 1) return this.propRegistro.registro.pessoas[0].nome
        else return this.propRegistro.registro.pessoas.map(pessoa => pessoa.nome || pessoa.nome_antigo).join('/')
      },
      reload () {
        this.$emit('reload')
      },
      showPendencias (name) {
        this.$refs[name].showBox()
      },
      getQtdErrors (errors) {
        if (Array.isArray(errors)) {
          return errors.length
        } else {
          return '1'
        }
      },
      getTipoComunicacao () {
        let tipoPrincipal = this.tipos[this.propRegistro.registro.tipo_registro] || 'Não identificado'
        let tipoSecundario = this.tipos[this.propRegistro.registroAnterior.tipo_comunicacao] || 'Não identificado'

        tipoPrincipal = tipoPrincipal[0].toUpperCase() + tipoPrincipal.substr(1)
        tipoSecundario = tipoSecundario[0].toUpperCase() + tipoSecundario.substr(1)

        return `Anotação de ${tipoPrincipal} para ${tipoSecundario}`
      },
      async averbar () {
        try {
          loader({text: 'Buscando dados...', active: true})

          const {tipo_comunicacao, termo, folha, livro} = this.propRegistro.registroAnterior

          const params = {
            tipo_livro: tipo_comunicacao,
            num_livro: livro,
            num_folha: folha,
            termo: termo,
            tipo_registro: tipo_comunicacao,
            cartorio_id: this.cartorioId
          }

          const { data: { data: registros }} = await BuscaService.searchREI(params)

          if (registros.length) {
            const ativo = registros.find(registro => registro.flag_ativo && !registro.flag_cancelado)

            if (ativo) {
              this.registro_id = ativo.registro_id

              this.showModal = true
            } else {
              return displayMessage('error', 'Não foi possível localizar o registro. Verifique os dados informados no registro anterior e tente novamente.')
            }
          } else {
            return displayMessage('error', 'Não foi possível localizar o registro. Verifique os dados informados no registro anterior e tente novamente.')
          }
        } catch (error) {
          displayMessage('error','Não foi possível consultar os dados do registro. Tente novamente mais tarde.')
        } finally {
          loader({text: '', active: false})
        }
      }
    }
  }
</script>
<style lang="scss">
  .BoxAnotacoes {
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;

    &_header {
      background: #FFFFFF;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;

      &_CUMPRIDA {
        background: #696969;
      }

      &_CUMPRIDA_MANUAL {
        background: #696969;
      }

      &_VENCIDA {
        background: #8b0000;
      }

      &_A_VENCER {
        background: #7f7e14;
      }
    }

    &_body {
      &_title {
        font-size: 15px;
        font-weight: bold;
        color: #373a3c;
        text-decoration: underline;
      }

      &_text {
        font-size: 15px;
        font-weight: normal;
        text-align: left;
        color: #373a3c;
      }

      &_tipo {
        width: 150px;
        text-align: justify;
      }

      &_second-line {
        padding-top: 5px;
      }
    }
  }

  .icon-cumprida-manual {
    fill: #FFFFFF;
  }
</style>
